import React, {useState} from "react";
import styles from "./RadioSelector.module.scss";
import radioOn from "../../../assets/images/radio-selected.svg";
import radioOff from "../../../assets/images/radio-empty.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";

const RadioSelector = props => {
  const [storedValue, setStoredValue] = useState(props.initialValue);
  return <div className={`${styles.checkboxesCont} clearfix ${props.className ? props.className : ''}`}>
    {props.title ?
      <div className={`${styles.tooltipedHeader} clearfix`}>
        <h3>
          {props.title}
          {props.id && props.tooltip ?
            [<FontAwesomeIcon
              className={styles.infoTooltipCont}
              icon={faInfoCircle}
              size="lg"
              data-tip={props.id}
              data-for={`rt-${props.id}`}
            />,
              <ReactTooltip place="bottom" type="info" effect="float" id={`rt-${props.id}`}>
                {props.tooltip}
              </ReactTooltip>] : null}
        </h3>
      </div>
      : null}
    {props.options.map(option => <div
      className={`${styles.checkbox} clearfix`}
      onClick={() => {
        props.onSelectionChange(option.value);
        setStoredValue(option.value)
      }}
    >
      {storedValue === option.value ?
        <img src={radioOn}/> : null}
      {storedValue !== option.value ?
        <img src={radioOff}/> : null}
      <div>{option.label}</div>
    </div>)}
  </div>
}

export default RadioSelector;
